export default __webpack_public_path__ + "static/media/top_back.de20243f.jpg";